export default __webpack_public_path__ + "static/media/006-heart.a5b43889.png";